import { CloseRounded, SearchRounded } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { MasterSchemeInterface } from "../../family_enquiries/family_enquiry_list";
import { Option } from "../../../needs/model/needs_filters";
import { useQuery } from "react-query";
import { getDistrictMasterData } from "../../../../services/master/master_service";
import { useFamilyEnquiriesFilterStore } from "../../../../store/use-scheme-family-enquiries-filter-store";
import { black, greyEnabled, purple, purpleLight } from "../../../../theme/colors";
interface FilterEnquiriesInterface {
  genderList: MasterSchemeInterface[];
  govermentList: MasterSchemeInterface[];
  states: MasterSchemeInterface[];
  category: MasterSchemeInterface[];
}

export default function FilterFamilyEnquiries({
  category,
  states,
  genderList,
  govermentList,
}: FilterEnquiriesInterface) {

const {
  openEnquiriesModal,
  setOpenEnquiriesModal,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  schemeKeyword,
  setSchemeKeyword,
  stateId,
  setStateId,
  categoryId,
  setCategoryId,
  districtId,
  setDistrictId,
  gender,
  setGender,
  ageFrom,
  setAgeFrom,
  ageTo,
  setAgeTo,
  governmentType,
  setGovernmentType,
  resetFilter,
  searchVal,
  setApplyFilter
} = useFamilyEnquiriesFilterStore();

  const [_endDate, _setEndDate] = useState<string>(endDate);
  const [_startDate, _setStartDate] = useState<string>(endDate);
  const [_schemeKeyword, _setSchemeKeyword] = useState(searchVal);
  const [_stateId, _setStateId] = useState<number | null>(stateId);
  const [_categoryId, _setCategoryId] = useState<number | null>(categoryId);
  const [_ageFrom, _setAgeFrom] = useState<number | null>(ageFrom);
  const [_ageTo, _setAgeTo] = useState<number | null>(ageTo);
  const [_districtId, _setDistrictId] = useState<number | null>(districtId);
  const [_selectedGender, _setSelectedGender] = useState<number | null>(gender);
  const [_governmentType, _setGovernmentType] = useState<number | null>(governmentType);

  useEffect(() => {
    if (_endDate != null && _startDate != null && _startDate > _endDate) {
      _setEndDate("");
    }
  }, [_startDate]);


  const { data: district, isFetching: isDistrictLoading } = useQuery(
    ["districtList", _stateId],
    async () => {
      if (_stateId) {
        let response = await getDistrictMasterData(_stateId);
        return response?.data?.data?.list;
      }
    }
  );


  const handleClose = () => setOpenEnquiriesModal(false);

  return (
    <Dialog open={openEnquiriesModal} onClose={handleClose} PaperProps={{ sx: { borderRadius: 4 } }}>
      <Box sx={{ minWidth: 400, maxWidth: "90vw" }}>
        <Card elevation={0} sx={{ px: 0 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ px: 3, pt: 2.5, pb: 1.5, borderBottom: "1px solid #ECECEC" }}
          >
            <Typography variant="h6" fontWeight={700} color={black}>
              Filter Family Enquiries
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseRounded sx={{ color: greyEnabled }} />
            </IconButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ px: 3, pt: 1.5 }}
          >
            <Typography variant="body2" fontWeight={600} color={black}>
              Filter By
            </Typography>
            <Button
              variant="text"
              sx={{ p: 0, textTransform: "none", fontWeight: 600, color: purple }}
              onClick={() => {
                resetFilter();
                _setEndDate("");
                _setStartDate("");
                _setAgeFrom(null);
                _setAgeTo(null);
                _setSelectedGender(null)
                _setStateId(null);
                _setDistrictId(null);
                _setGovernmentType(null)
                setOpenEnquiriesModal(false);
                setApplyFilter(true)
              }}
            >
              Reset
            </Button>
          </Box>
          <CardContent sx={{ px: 3, maxHeight: 400, overflow: "auto scroll" }}>
            <Typography fontSize={16} fontWeight="600" color={black}>
              Scheme
            </Typography>
            <TextField
              value={_schemeKeyword}
              onChange={(e) => _setSchemeKeyword(e.target.value)}
              fullWidth
              variant="outlined"
              label={"Search for scheme"}
              placeholder={"Search for scheme"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <SearchRounded sx={{ color: greyEnabled, fontSize: 20 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ mt: 1 }}
            />
            <Divider sx={{ mt: 2, mb: 1 }} />
            {_dropdownOption({
              title: "Category",
              placeholder: "Search for Category",
              options: category,
              selectedId: _categoryId,
              onSelect: (id) => {
                _setCategoryId(id);
              },
            })}
            {_dropdownOption({
              title: "Government Type",
              placeholder: "Search for Government Type",
              options: govermentList,
              selectedId: _governmentType,
              onSelect: (id) => {
                _setGovernmentType(id);
              },
            })}
            {_dropdownOption({
              title: "State",
              placeholder: "Search for State",
              options: states,
              selectedId: _stateId,
              onSelect: (id) => {
                _setStateId(id);
              },
            })}
            {_dropdownOption({
              title: "District",
              placeholder: isDistrictLoading ? "Loading districts..." : "Select District",
              selectedId: _districtId,
              onSelect: (id) => {
                _setDistrictId(id);
              },
              disabled: !_stateId || isDistrictLoading,
              loading: isDistrictLoading,
              options:
                district?.map((city: any) => {
                  return { id: city.id, value: city?.value };
                }) || [],
            })}
            {_dateRange({
              title: "Date Range",
              setEndDate: _setEndDate,
              setStartDate: _setStartDate,
              startDate: _startDate,
              endDate: _endDate,
            })}
            {/* <Box display="flex" flexDirection={"row"} mt={2}>
              <TextField
                value={_ageFrom}
                fullWidth
                sx={{ mr: 2 }}
                label="From Age"
                placeholder="set from age"
                onChange={(e) => {
                  _setAgeFrom(+e.target.value);
                }}
              />
              <TextField
                value={_ageTo}
                fullWidth
                sx={{ mr: 2 }}
                label="To Age"
                placeholder="set To age"
                onChange={(e) => {
                  _setAgeTo(+e.target.value);
                }}
              />
            </Box> */}
            {/* <Divider sx={{ mt: 2, mb: 1 }} /> */}
            <Typography mt={2} fontSize={16} fontWeight="600" color={black} mb={1}>
              Gender
            </Typography>
            <Box>
              {genderList?.map((gender) => {
                const isSelected = _selectedGender === gender.id;
                return (
                  <Button
                    key={gender?.id}
                    onClick={() => {
                      if (_selectedGender === gender?.id) {
                        _setSelectedGender(null);
                      } else {
                        _setSelectedGender(gender?.id);
                      }
                    }}
                    variant={isSelected ? "contained" : "outlined"}
                    disableElevation
                    sx={{
                      mr: 1,
                      mb: 1,
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: 2,
                      ...(isSelected
                        ? { bgcolor: purple, "&:hover": { bgcolor: "#7A2074" } }
                        : {
                            borderColor: purple,
                            color: purple,
                            "&:hover": { borderColor: purple, bgcolor: purpleLight },
                          }),
                    }}
                  >
                    {gender?.value}
                  </Button>
                );
              })}
            </Box>
            <Box mt={3} display="flex" justifyContent="space-between" gap={1.5}>
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{
                  borderColor: purple,
                  color: purple,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": { borderColor: purple, bgcolor: purpleLight },
                }}
              >
                Cancel
              </Button>
              <Button
                sx={{
                  minWidth: 200,
                  bgcolor: purple,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": { bgcolor: "#7A2074" },
                }}
                variant="contained"
                disableElevation
                onClick={() => {
                  setStartDate(_startDate);
                  setEndDate(_endDate);
                  setSchemeKeyword(_schemeKeyword);
                  setCategoryId(_categoryId);
                  setStateId(_stateId);
                  setOpenEnquiriesModal(false);
                  setAgeFrom(_ageFrom);
                  setAgeTo(_ageTo);
                  setGender(_selectedGender);
                  setDistrictId(_districtId);
                  setGovernmentType(_governmentType)
                  setApplyFilter(true)
                }}
              >
                Apply Filters
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Dialog>
  );

  function _dropdownOption({
    title,
    placeholder,
    options,
    selectedId,
    onSelect,
    disabled = false,
    loading = false,
  }: {
    title: string;
    placeholder: string;
    options: { id: number; value: string }[];
    selectedId: number | null;
    onSelect: (id: number | null) => void;
    disabled?: boolean;
    loading?: boolean;
  }) {
    return (
      <Box pt={2} pb={1}>
        <Typography fontSize={16} fontWeight="600" color={black}>
          {title}
        </Typography>
        <Box pt={1} pb={2} display="flex" flexDirection="row">
          <Autocomplete
            fullWidth
            disabled={disabled}
            loading={loading}
            value={options.find((option) => selectedId === option?.id) || null}
            onChange={(e, value) => {
              onSelect(value?.id || null);
            }}
            options={options}
            getOptionLabel={(option) => option?.value}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={placeholder}
                placeholder={placeholder}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress size={16} sx={{ color: purple }} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Box>
        <Divider />
      </Box>
    );
  }

  function _dateRange({
    title,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  }: {
    title: string;
    startDate: string;
    setStartDate: (value: string) => void;
    endDate: string;
    setEndDate: (value: string) => void;
  }) {
    return (
      <Box pt={2} pb={1}>
        <Typography fontSize={16} fontWeight="600" color={black}>
          {title}
        </Typography>
        <Box pt={1} pb={2} display="flex" flexDirection={"column"}>
          <DatePicker
            label="Start Date"
            format="DD-MM-YYYY"
            disableFuture
            value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
            onChange={(value: Dayjs | null) => {
              setStartDate(value?.format("YYYY-MM-DD") || "");
            }}
            slotProps={{ desktopPaper: { elevation: 3 } }}
            sx={{
              "& .MuiSvgIcon-root": {
                fill: "#990099", // Replace with your desired color
              },
            }}
          />
          <Box p={1}></Box>
          <DatePicker
            label="End Date"
            format="DD-MM-YYYY"
            disableFuture
            value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
            onChange={(value: Dayjs | null) => {
              setEndDate(value?.format("YYYY-MM-DD") || "");
            }}
            slotProps={{ desktopPaper: { elevation: 3 } }}
            minDate={dayjs(startDate, "YYYY-MM-DD")}
            sx={{
              "& .MuiSvgIcon-root": {
                fill: "#990099", // Replace with your desired color
              },
            }}
          />
        </Box>
      </Box>
    );
  }
}
